import api from "./apis/api";

class StrippingService {
  addNewStrippingApi(payload) {
    return api.stripping.addNewStrippingApi(payload);
  }

  getStrippingProcessListApi(payload) {
    return api.stripping.getStrippingProcessListApi(payload);
  }

  getStrippingProcessByIdApi(processId) {
    return api.stripping.getStrippingProcessByIdApi(processId);
  }

  updateStrippingProcessByIdApi(payload) {
    return api.stripping.updateStrippingProcessByIdApi(
      payload?.processId,
      payload?.archivedObj,
    );
  }

  getStrippingProcessDataApi(payload) {
    return api.stripping.getStrippingProcessDataApi(payload);
  }

  updateStrippingProcessDataByIdApi(payload) {
    return api.stripping.updateStrippingProcessDataByIdApi(
      payload?.strippingProcessDataId,
      payload?.payload,
    );
  }

  getProcessDataById(strippingProcessDataId) {
    return api.stripping.getProcessDataById(strippingProcessDataId);
  }

  addStrippingProcessDataApi(payload) {
    return api.stripping.addStrippingProcessDataApi(payload);
  }

  sendToStrippingProcessApi(payload) {
    return api.stripping.sendToStrippingProcessApi(payload);
  }

  addWasteWaterData(payload) {
    return api.stripping.addWasteWaterData(payload);
  }

  updateWasteWater(payload) {
    return api.stripping.updateWasteWater(
      payload?.wasteWaterId,
      payload?.payload,
    );
  }

  getWasteWaterList(payload) {
    return api.stripping.getWasteWaterList(payload);
  }

  addStrippingSubLogData(payload) {
    return api.stripping.addStrippingSubLogData(payload);
  }

  updateStrippingSubLog(payload) {
    return api.stripping.updateStrippingSubLog(
      payload?.subLogId,
      payload?.payload,
    );
  }

  deleteStrippingSubLog(subLogId) {
    return api.stripping.deleteStrippingSubLog(subLogId);
  }

  getStrippingSubLogList(payload) {
    return api.stripping.getStrippingSubLogList(payload);
  }
}

export default new StrippingService();
